<template>
  <div class="c-light-box-video-poster">
    <div class="c-light-box-video-poster__inner">
      <div class="c-light-box-video-poster__inner__spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.c-light-box-video-poster {
  &__inner {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex: 1;
    height: 100%;
  }
}

.c-light-box-video-poster__inner__spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.c-light-box-video-poster__inner__spinner div {
  transform-origin: 40px 40px;
  animation: c-light-box-video-poster__inner__spinner 1.2s linear infinite;
}
.c-light-box-video-poster__inner__spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: $color-dark;
}
.c-light-box-video-poster__inner__spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.c-light-box-video-poster__inner__spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes c-light-box-video-poster__inner__spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
